"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const expression_1 = require("../expression");
const node_1 = require("../../node");
class TwingNodeExpressionMethodCall extends expression_1.TwingNodeExpression {
    constructor(node, method, methodArguments, lineno, columnno) {
        let nodes = new Map();
        nodes.set('node', node);
        nodes.set('arguments', methodArguments);
        let attributes = new Map();
        attributes.set('method', method);
        attributes.set('safe', false);
        super(nodes, attributes, lineno, columnno);
        this.type = node_1.TwingNodeType.EXPRESSION_METHOD_CALL;
    }
    compile(compiler) {
        compiler
            .subcompile(this.getNode('node'))
            .raw('.')
            .raw(this.getAttribute('method'))
            .raw('(');
        let first = true;
        let argumentsNode = this.getNode('arguments');
        for (let pair of argumentsNode.getKeyValuePairs()) {
            if (!first) {
                compiler.raw(', ');
            }
            first = false;
            compiler.subcompile(pair['value']);
        }
        compiler.raw(')');
    }
}
exports.TwingNodeExpressionMethodCall = TwingNodeExpressionMethodCall;
